import { LoaderXs } from '@sketchnote/shared-components';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useBoardStore } from 'src/features/boards';
import { Board, useKanbanStore } from 'src/features/kanban';

import { getSprintBoard } from '../../api/useAgileService';
import { useAgileStore } from '../../store';

export const Kanban = () => {
  const { setActiveSprints, selectedSprintIds } = useAgileStore((s) => ({
    setActiveSprints: s.setActiveSprints,
    selectedSprintIds: s.selectedSprintIds,
  }));

  const [isLoading, setLoading] = useState(false);
  const router = useRouter();
  const fileId = router?.query?.slug;
  const filters = useBoardStore((s) => s.filters);

  useEffect(() => {
    const fetchSprintBoard = async () => {
      const data = await getSprintBoard(fileId as string, selectedSprintIds, filters);

      useKanbanStore.setState({
        columns: data?.boardData.columns,
        boardId: data?.boardData.id,
      });
      useBoardStore.setState({
        key: data?.boardData.key,
      });
      setActiveSprints(
        data?.activeSprints.map((sprint) => ({
          ...sprint,
          checked: false,
        }))
      );
      setLoading(false);
    };
    setLoading(true);
    fetchSprintBoard();
  }, [filters, selectedSprintIds]);

  return (
    <>
      {isLoading ? (
        <div className="h-screen w-full mt-48">
          <div className="overflow-hidden">
            <LoaderXs className="mx-auto text-xss" />
          </div>
        </div>
      ) : (
        <Board />
      )}
    </>
  );
};
